<template>
    <div>
        <!--库存预警-->
        <header class="form-title">
            <Row>
                <Col span="16">
                    <Form  inline  :label-width="80" >
                        <FormItem  label="库存数量:" style="margin-right: 30px">
                            <strong class="result">{{dataTotl.num}}</strong>
                        </FormItem>
                        <FormItem  label="库存成本:" style="margin-right: 30px"  v-if="isroule">
                            <strong class="result">{{dataTotl.summoney}}</strong>
                        </FormItem>
                        <FormItem  label="预警单品:" style="margin-right: 30px">
                            <strong class="result">{{dataTotl.warning}}</strong>
                        </FormItem>
                    </Form>
                </Col>
                <Col span="8" align="right">
                    <Form  inline>
                        <FormItem>
                            <Input  style="width: 200px" v-model="condition" placeholder="商品名称、货号" />
                            <Button type="primary" style="margin-left: 15px" @click="searchCondition">搜索</Button>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        </header>
        <Table stripe :columns="columns" :data="data" :loading="loadingTable" class="tableList">
            <template slot-scope="{ row, index }" slot="first">
                <Fy-Img
                        class="img"
                        :ImgSrc="row.goodsimg | filtImg(row.goodsimg)"
                        :Width="50"
                        :Height="50"
                ></Fy-Img>
            </template>
            <template slot-scope="{ row, index }" slot="warning">
               <span style="color: #ff5e5e">
                   {{row.warning}}
               </span>
            </template>

        </Table>
        <div class="pageTotal"  >
            <Page :total="page.total"
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal" />
        </div>
    </div>
</template>
<script>
    import FyImg from "../../components/Common/FyImg";
    import expandRow from '../../components/Common/table-expand';
    export default {
        components: {FyImg,expandRow},
        data() {
            return {
                cid:'',
                sid:'',
                condition:'', //搜多内容
                expandRow:'',
                columns: [
                    {
                        width: 50,
                        type: 'expand',
                        render: (h, params) => {
                            return h(expandRow, {
                                props: {
                                    row: params.row
                                }
                            })
                        }
                    },
                    {title: '图片', key: 'goodsimg',align:'center',slot: 'first'},
                    {title: '商品名称', key: 'name',align:'center' },
                    {title: '货号', key: 'goodscode' ,align:'center' },
                    {title: '总库存', key: 'all' ,align:'center' },
                    {title: '预警下线', key: 'warning',align:'center',slot: 'warning'  },
                ],
                data: [],
                dataTotl:{
                    num: 0,
                    summoney:0,
                    warning: 0
                },
                page:{
                    total:0,
                    page:1,
                    rows:8
                },
                loadingTable:true,
                isroule:true
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getGoodsWarningNum(this.page.page,this.page.rows)
            this.getWaringNums(this.page.page,this.page.rows)
            var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
            if(!PermisCode.includes('94')){
                this.isroule=false
            }
        },
        watch: {
            'condition': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getGoodsWarningNum(this.page.page,this.page.rows)
                }
            },
        },
        methods: {
            searchCondition(){
                this.getGoodsWarningNum(this.page.page,this.page.rows)
            },
            //获取列表
            getGoodsWarningNum(page,rows){
                this.$Api.getWarningList({
                    cid: this.cid,
                    sid: this.sid,
                     condition:this.condition,
                    page: page,
                    rows: rows,
            }).then(res => {
                    if(res.code==200){
                        this.data=[]
                        this.page.total = res.count
                        res.data.forEach((item,index)=>{
                                var PurchaseList={}
                                var nums=0
                                PurchaseList.id = item.id,
                                PurchaseList.goodsimg = item.goodsimg,
                                PurchaseList.name = item.name,
                                PurchaseList.goodscode = item.goodscode,
                                item.warnings.forEach((m,n)=>{
                                    nums=nums + parseInt(m.num)
                                })
                                PurchaseList.all=nums
                                PurchaseList.warning = item.warning,
                                PurchaseList.expand=item.warnings,
                               this.data.push(PurchaseList)
                        })

                        this.loadingTable=false
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            getWaringNums(page,rows){
                this.$Api.selectStockList({
                    cid: this.cid,
                    sid: this.sid,
                    page: page,
                    rows: 10,
                    typeGoods:'',
                    typeItems:''
                }).then(res => {
                    if(res.code==200){
                        this.dataTotl.num=res.num
                        this.dataTotl.summoney=res.summoney
                        this.dataTotl.warning=res.warning
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            onGongPageTotal(num){
                this.getGoodsWarningNum(num,this.page.rows)
            }
        }
    };
</script>

<style lang="scss"  scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .result{
        color: #ff5e5e;
    }
    .tableFirst{
        color: #ff5e5e;
    }
    .tableList .ivu-table-row td{
        padding: 10px 0;
        .img{
            display: block;
            margin:10px auto;
        }
    }

</style>